import axios from "axios";
import store from "../../store/index";
import moment from "moment";
import { data } from "jquery";

export default {
    name: "ChangeCategoryPopup",
    props: {
        templateId: {
            type: String,
            default: ""
        },
        selectedCategory: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            baseurl: process.env.VUE_APP_Service_URL,
            idtoken: "",
            category: "",
            categories: [],
            categoryId: "",
        }

    },
    mounted() {
        document.body.style.overflowY = "hidden"
        console.log("templateId", this.templateId);
        this.category = this.selectedCategory;
        this.fetchCategories();

    },
    unmounted() {
        document.body.style.overflowY = "auto"
    },
    methods: {
        closeCategoryModal() {
            this.$emit("closeModal")
        },
        async fetchCategories() {
            this.idtoken = store.getters.getIdToken;
            try {
                const response = await axios.get(
                    `${this.baseurl}/management/master/getallformcategories`,
                    {
                        headers: {
                            Authorization: "Bearer " + this.idtoken
                        }
                    }
                );
                this.categories = response.data.filter(c => c.isActive);

                // Pre-select existing category if available
                const selected = this.categories.find(
                    c => c.formCategory === this.selectedCategory
                );
                if (selected) {
                    this.categoryId = selected.id;
                }
            } catch (error) {
                console.error("Error fetching categories:", error);
            }
        },
        onCategoryChange(event) {
            const selectedId = event.target.value;
            const selected = this.categories.find(cat => cat.id === selectedId);
            if (selected) {
                this.category = selected.formCategory;
                this.categoryId = selected.id;
            }
        },
        async chageCategory() {
            this.idtoken = store.getters.getIdToken;
            try {
                const response = await axios.put(
                    `${this.baseurl}/forms/template/changecategory?templateId=${this.templateId}&Category=${this.category}&CategoryId=${this.categoryId}`
                    // `https://localhost:5002/template/changecategory?templateId=${this.templateId}&Category=${this.category}&CategoryId=${this.categoryId}`
                    , {},

                    {
                        headers: {
                            Authorization: "Bearer " + this.idtoken,
                            "Content-Type": "application/json"
                        }
                    }
                );
                if (response.data == "Template categoy changed successfully.") {
                    alert(this.$t("navigations.form category changed successfully"));
                    this.closeCategoryModal();
                } else {
                    alert("Failed to change category. Please try again.");
                    this.closeCategoryModal();
                }
            } catch (error) {
                console.error("Error changing category:", error);
            }
        }
    }
}